import { render, staticRenderFns } from "./CheckInDossierDialog.vue?vue&type=template&id=063f4bf2&scoped=true"
import script from "./CheckInDossierDialog.vue?vue&type=script&lang=ts"
export * from "./CheckInDossierDialog.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "063f4bf2",
  null
  
)

export default component.exports